import updateProvider from './updateProvider'
import fetchProvider from './fetchProviderInfo'

export default {
  updateProvider,
  fetchProvider
}


// WEBPACK FOOTER //
// ./src/services/provider/index.js